import i18n from '@dms/i18n';

import {CO2_CLASS_OPTIONS} from '../constants/CO2_CLASS_OPTIONS';
import {Field} from './primitives/Field';

export function CarbonDioxideEmissionClassSelect() {
  return (
    <Field
      type="choice"
      name="carbonDioxideEmissionClass"
      label={i18n.t('entity.vehicle.labels.carbonDioxideEmissionClass')}
      options={CO2_CLASS_OPTIONS}
    />
  );
}
